<script>
    import { metaInfo } from "@/core/MetaInfo";
    import BaseButton from "@main/packages/BaseButton";
    import TypographyWrapper from "@/components/TypographyWrapper";
    import LinkWithAnalytics from "@/components/LinkWithAnalytics";
    import { mapState } from "vuex";

    export default {
        name: "Corporate",
        components: { LinkWithAnalytics, BaseButton, TypographyWrapper },
        computed: {
            ...mapState("Root", {
                staticText: (state) => state.site.staticTextContent,
            }),
            staticTextContent() {
                return this.staticText?.find((t) => t.key === "corporate")?.value;
            },
            images() {
                return [
                    "1.svg",
                    "2.png",
                    "3.png",
                    "4.png",
                    "5.svg",
                    "6.svg",
                    "7.svg",
                    "8.png",
                    "9.svg",
                    "10.svg",
                    "11.svg",
                    "12.svg",
                    "13.svg",
                    "14.svg",
                ];
            },
        },
        metaInfo() {
            return metaInfo.getMeta("corporate");
        },
    };
</script>

<template>
    <div class="corporate-page">
        <div class="l-container">
            <typography-wrapper>
                <h1 class="page-title">Корпоративный заказ</h1>

                <div class="corporate-page__text">
                    <div v-html="staticTextContent"></div>
                    <div class="corporate-page__images">
                        <div
                            class="corporate-page__image"
                            v-for="(image, index) in images"
                            :key="index"
                        >
                            <img :src="`/static/zavtra/assets/corporate/${image}`" alt="" />
                        </div>
                    </div>
                    <p>
                        Продукт ZAVTRA не&nbsp;отложат в&nbsp;сторону и&nbsp;он&nbsp;быстро
                        не&nbsp;сломается&nbsp;&mdash; его будут носить до&nbsp;тех пор пока
                        он&nbsp;не&nbsp;станет винтажным раритетом.
                    </p>
                </div>

                <base-button
                    class="corporate-page__button"
                    variant="v1"
                    size="lg"
                    @click="$router.push({ name: 'Home', hash: '#catalog' })"
                >
                    Перейти к покупкам
                </base-button>
            </typography-wrapper>
        </div>
    </div>
</template>

<style lang="scss">
    .corporate-page {
        padding-bottom: 40px;
        button {
            margin: 0 auto;
        }
        @include bp($bp-desktop-sm) {
            padding-bottom: 56px;
        }
    }

    .corporate-page__text {
        margin-bottom: 20px;
        @include bp($bp-desktop-sm) {
            max-width: 900px;
            margin: 0 auto 20px;
        }
    }

    .corporate-page__images {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin: 24px -5px 0;
        @include bp($bp-desktop-sm) {
            margin: 40px -12px 0;
        }
    }

    .corporate-page__image {
        flex-basis: 33.33334%;
        max-width: 33.33334%;
        padding: 0 5px 10px;
        @include bp($bp-desktop-sm) {
            flex-basis: 25%;
            max-width: 25%;
            padding: 0 12px 24px;
        }
    }

    .corporate-page__button {
        width: 100%;
        max-width: 320px;
    }
</style>
